import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import RunningClubListPage from './running-club-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Running Clubs">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Running Clubs</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <RunningClubListPage />
    </Panel>
  );
};

export default Page;
